import React from 'react';
import Select from "react-select";
import { API } from "aws-amplify";
import { toast } from "react-toastify";
import _ from "lodash";
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';

import AiIcon from '@/common/AiIcon';
import { canQASurveys, isIgnoreAnswerEnabled, isAiSentimentAnalysisEnabled, isAiDisclosureEnabled, isExpandedSentimentTypesEnabled } from "@/shared/access";
import { sentiments, expandedSentiments } from "@/utils/utils";

function SurveyResultsAnswerChoice({ question, answer, setAnswerIgnored }) {
    return (
        <div className="answerCell answerChoice">
            <div className="surveyQuestion">{question.prompt}</div>

            <div className="surveyAnswers">
                {
                    _.map(question.options, function (o) {
                        return (
                            <div key={o.id} className={`surveyAnswer ${(answer && answer.selectedOption && answer.selectedOption.id == o.id) ? 'selected' : ''}`}>
                                <div className="answerTitle">{o.option}</div>
                            </div>
                        )
                    })
                }
            </div>

            {/* {(isIgnoreAnswerEnabled() && answer) &&
        <div>
          <FormControlLabel
            disabled={!canQASurveys()}
            checked={answer.ignored}
            onChange={() => setAnswerIgnored(answer, !answer.ignored, question)}
            className="answerIgnore"
            control={<Checkbox color="primary" />}
            label="Exclude Rating"
          />
          {answer.ignored && (
            <div className="answerIgnoreComment">
              {"Reason: "}
              {answer.ignoredComment ? answer.ignoredComment : ""}
            </div>
          )}
        </div>
      } */}
        </div>
    );
}

function SurveyResultsAnswerScale({ question, answer, setAnswerIgnored }) {
    return (
        <div className="answerCell answerScale">
            <div className="surveyQuestion">{question.prompt}</div>

            <div className="surveyAnswers">
                {answer ?
                    _.map(_.range(question.low, question.high + 1), function (i) {
                        return (
                            <div key={i} className={`surveyAnswer ${answer.rangeSelection === i ? 'selected' : ''}`}>
                                <div className="answerTitle">{i}</div>
                            </div>
                        )
                    }) : ""
                }
            </div>

            <div className="answersLabels">
                <div className="label min">{question.lowDescription ? question.lowDescription : ''}</div>
                <div className="label max">{question.highDescription ? question.highDescription : ''}</div>
            </div>

            {(isIgnoreAnswerEnabled() && answer) &&
                <div>
                    <FormControlLabel
                        disabled={!canQASurveys()}
                        checked={answer.ignored}
                        onChange={() => setAnswerIgnored(answer, !answer.ignored, question)}
                        className="answerIgnore"
                        control={<Checkbox color="primary" />}
                        label="Exclude Rating"
                    />
                    {answer.ignored && (
                        <div className="answerIgnoreComment">
                            {"Reason: "}
                            {answer.ignoredComment ? answer.ignoredComment : ""}
                        </div>
                    )}
                </div>
            }
        </div>
    );
}

function SurveyResultsAnswerComment({ question, answer, setAnswerIgnored }) {

    const saveButtonRef = React.useRef(null);
    const [sentiment, setSentiment] = React.useState(answer ? answer.sentiment : "");
    const [noteworthy, setNoteworthy] = React.useState(answer ? !!answer.noteworthy : false);
    const [currentAnswer, setCurrentAnswer] = React.useState(answer);

    const saveSentiment = () => {
        currentAnswer.sentiment = sentiment;
        currentAnswer.noteworthy = noteworthy;
        API.put('Core', '/api/v1/survey/answer/sentiment/' + currentAnswer.id, { body: currentAnswer })
            .then(response => {
                setCurrentAnswer(response);
            },
                error => {
                    toast("Could not update answer sentiment: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const setModififedSentiment = (obj) => {
        if (obj != null) {
            setSentiment(obj.value);
        }
    }
    const getSelectAriaLabel = () => {
        let label = `sentiment combobox: selected option ${sentiment || 'none'}`;
        if (answer?.aiReasoning && isAiSentimentAnalysisEnabled()) {
            label += `. AI Reasoning: ${answer.aiReasoning}`;
            label += `. Generated by AI.`;
        }
        label += `. Use arrow key or press enter to activate the menu and select an option`;
        return label;
    }
    const screenReaderStatus = () => '';
    const ariaLiveMessages = {
        guidance: () => '',
        onChange: () => '',
        onFilter: () => '',
        onFocus: () => ''
    };

    return (
        <div className="answerCell answerComment">
            <div className="surveyQuestion">{question.prompt}</div>
            <div className="surveyAnswers">
                {currentAnswer ? (
                    <div className="surveyAnswer">
                        <div className="answerTitle">{answer.normalizedAnswer}</div>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {(isExpandedSentimentTypesEnabled() && currentAnswer) && (
                <FormControlLabel
                    disabled={!canQASurveys()}
                    className="answerNoteworthy"
                    label="Noteworthy Feedback"
                    control={
                        <Checkbox
                            color="primary"
                            checked={noteworthy}
                            onChange={() => setNoteworthy(prev => !prev)}
                            inputProps={{
                                id: "noteworthyCheckbox",
                                "aria-label": "Noteworthy Feedback",
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Tab') {
                                    e.preventDefault();
                                    document.getElementById('sentimentTypeSelect')?.focus();
                                }
                            }}
                        />
                    }
                    htmlFor="noteworthyCheckbox"
                />
            )}
            {currentAnswer ? (
                <div
                    className="sentimentRow"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                    }}
                >
                    {/* Sentiment Section */}
                    <div className="tableCell titledSelectCell sentimentSelect">
                        <label className="title" htmlFor="sentimentTypeSelect" id="sentiments1">
                            Sentiment
                        </label>
                        <Select
                            inputId="sentimentTypeSelect"
                            className="selectCell"
                            classNamePrefix="selectCell"
                            onChange={setModififedSentiment.bind(this)}
                            placeholder="Sentiment"
                            value={sentiment !== "" ? { label: sentiment, value: sentiment } : ""}
                            isDisabled={!canQASurveys()}
                            options={isExpandedSentimentTypesEnabled() ? expandedSentiments : sentiments}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, color: "black" }),
                            }}
                            aria-label={getSelectAriaLabel()}
                            screenReaderStatus={screenReaderStatus}
                            ariaLiveMessages={ariaLiveMessages}
                            role="combobox"
                        />
                        {(currentAnswer.sentiment !== sentiment || currentAnswer.noteworthy !== noteworthy) && canQASurveys() ? (
                            <div
                                ref={saveButtonRef}
                                role="button"
                                tabIndex={0}
                                aria-label="Save"
                                onClick={saveSentiment.bind(this)}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); saveSentiment(); } }}
                                className="button medium tint"
                                style={{ marginTop: "0.5rem" }}
                            >
                                <div className="title">Save</div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    {/* Reason Section - aligned horizontally */}
                    {isAiSentimentAnalysisEnabled() && answer?.aiReasoning ? (
                        <div className="answerIgnoreComment"
                             style={{marginTop: "1em"}}
                        >
                            {"AI Reasoning: "}
                            {answer.aiReasoning}
                        </div>
                    ) : null}

                </div>
            ) : (
                ""
            )}

            {currentAnswer && isAiDisclosureEnabled() && currentAnswer.aiReasoning && (
                <div className="aiGeneratedBadge" aria-label="Generated by AI">
                    <AiIcon size={15} />
                    <span className="aiGeneratedText">Generated by AI</span>
                </div>
            )}

            {/*<div className="button action medium">*/}
            {/*  <div className="title">Add to Feedback Board</div>*/}
            {/*</div>*/}

            {/* {(isIgnoreAnswerEnabled() && answer) &&
        <div>
          <FormControlLabel
            disabled={!canQASurveys()}
            checked={answer.ignored}
            onChange={() => setAnswerIgnored(answer, !answer.ignored, question)}
            className="answerIgnore"
            control={<Checkbox color="primary" />}
            label="Exclude Rating"
          />
          {answer.ignored && (
            <div className="answerIgnoreComment">
              {"Reason: "}
              {answer.ignoredComment ? answer.ignoredComment : ""}
            </div>
          )}
        </div>
      } */}
        </div>
    );
}

export { SurveyResultsAnswerChoice, SurveyResultsAnswerScale, SurveyResultsAnswerComment };